// JS
import React from 'react';
import { renderHTML, ppHeadingOverridesClose } from '../shared/utils';

/* SIZE GUIDES - PIM */
import ProductSizesGuide from '../ProductSizesGuide';

// SIZE GUIDES - OLD & FOOTWEAR
import * as sizeGuide from '../ProductSizes/existingSizeGuide';

// COMPONENT
const ProductSizesPopup = ({
  showHideSizeGuide,
  setShowHideSizeGuide,
  isMobile,
  data,
  setProdSku,
  sizeSelect,
  setSizeSelect,
  sizeGuideSelect,
  setSizeGuideSelect,
  setMiniBasketSize,
  setMiniBasketProdSku,
  setAtbButtonTxt,
  devOrProd,
  prodCat,
  monetateSizeGuide,
  hasQueryParams,
  productSize,
  setProductSize
}) => {
  const closeSizeGuideCleanUp = () => {
    setShowHideSizeGuide(false);
    window.scrollLock();
    ppHeadingOverridesClose();
  };

  const devOrProdCatList = () => {
    return (
      //monetateSizeGuide() &&
      /*(devOrProd === 'dev' || monetateSizeGuide() || hasQueryParams()) &&*/
      prodCat.some((el) => data.product.categorylist.includes(el))
    );
  };

  const footwearCat = ['FM_FOOTWEAR', 'FM_LUXURY', 'FM_SNEAKERS'];

  const checkForAttribute = () => {
    return (
      data.product.option.attributes.pittopitinches ||
      data.product.option.attributes.waistinches ||
      data.product.option.attributes.heightinches
    );
  };

  return (
    <>
      {showHideSizeGuide && data && data.product && (
        <div
          id="size-guide-overlay"
          className={isMobile ? 'fade-in-left' : 'animate-fadeIn'}
          onClick={(e) => {
            if (e.currentTarget === e.target && !isMobile) {
              setTimeout(() => {
                closeSizeGuideCleanUp();
              }, '400');
              document.getElementById('size-guide-overlay').className = isMobile
                ? 'fade-out-right'
                : 'animate-fadeOut';
            }
          }}
        >
          <div
            className={`size-guide-content ${
              devOrProdCatList() &&
              checkForAttribute() &&
              'overflow-y-scroll whitespace-nowrap'
            }`}
          >
            <div
              className={`size-guide-details ${
                devOrProdCatList() &&
                checkForAttribute() &&
                '!pt-[22px] !pb-[40px] !px-[20px] lg:!pr-10 lg:!pl-5 lg:!py-5'
              }`}
            >
              <div
                id="size-guide-details-close"
                onClick={() => {
                  setTimeout(() => {
                    closeSizeGuideCleanUp();
                  }, '400');
                  document.getElementById('size-guide-overlay').className =
                    isMobile ? 'fade-out-right' : 'animate-fadeOut';
                }}
              >
                {renderHTML(null, 'close')}
              </div>
              <div
                className={`size-guide-details-copy ${
                  devOrProdCatList() && checkForAttribute() && '!mt-0'
                }`}
              >
                {footwearCat.some((el) =>
                  data.product.categorylist.includes(el)
                ) ? (
                  sizeGuide.footwearSizeGuide
                ) : devOrProdCatList() && checkForAttribute() ? (
                  <ProductSizesGuide
                    data={data}
                    setProdSku={setProdSku}
                    sizeSelect={sizeSelect}
                    setSizeSelect={setSizeSelect}
                    sizeGuideSelect={sizeGuideSelect}
                    setSizeGuideSelect={setSizeGuideSelect}
                    setMiniBasketSize={setMiniBasketSize}
                    setMiniBasketProdSku={setMiniBasketProdSku}
                    setAtbButtonTxt={setAtbButtonTxt}
                    isMobile={isMobile}
                    productSize={productSize}
                    setProductSize={setProductSize}
                  />
                ) : (
                  sizeGuide.clothingSizeGuide
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductSizesPopup;
